const DWM = [
    {id: "0", value: "日"},    
    {id: "1", value: "週"},
    {id: "2", value: "月"}    
  ];  
  
  export default DWM